<template>
  <div id="scroll-top">
    <template v-if="user && user.account_type">
      <counselor-messages-impl
        v-if="isUser"
        mode="receiver"
        :target_user_id="user.id"
      />

      <btn-container>
        <basic-btn to="/">トップへ戻る</basic-btn>
      </btn-container>
      <spacer :y="3" />

      <not-found
        v-if="!isUser"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CounselorMessagesImpl from '@/views/pages/Common/CounselorMessagesImpl.vue';
import NotFound from '@/views/404.vue';
import Spacer from '@/views/components/Spacer.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';

export default {
  name: 'UserCounselorMessages',
  components: {
    CounselorMessagesImpl,
    NotFound,
    Spacer,
    BtnContainer,
    BasicBtn,
  },
  data() {
    return {
      flag: {
        loader: true,
      },
    };
  },
  computed: {
    ...mapState(['user']),
    isUser() {
      return this.user && this.user.account_type === 1;
    },
  },
  watch: {
    // ルートが変わるたびに実行
    $route() {
      this.$nextTick(() => {
        this.scroll2Top();
      });
    },
  },
  mounted() {
    // 初回マウント時にも実行
    this.$nextTick(() => {
      this.scroll2Top();
    });
  },
  methods: {
    scroll2Top() {
      // 上までスクロール
      const elem = document.getElementById('scroll-top');
      const position = elem.getBoundingClientRect().top;
      scrollBy(0, position - 77);
    },
  },
};
</script>

<style lang="scss" module>
</style>
